import { EditorExtensionEnum as t } from "../enums/editor-extensions-enum.mjs";
const e = [
  t.Document,
  t.Paragraph,
  t.Text,
  t.History
], n = [
  ...e,
  t.Bold,
  t.Italic,
  t.Strike,
  t.Underline,
  t.BulletList,
  t.OrderedList,
  t.ListItem,
  t.HardBreak
], i = [
  ...e,
  ...n,
  t.TextStyle,
  t.FontFamily,
  t.Heading,
  t.TextAlign,
  t.Link,
  t.TextColor,
  t.TextBackgroundColor,
  t.FontSize,
  t.LineHeight,
  t.Indent,
  t.HardBreak,
  t.SpecialCharacters,
  t.Image,
  t.DropCursor
], r = [
  ...i,
  t.Substitution
], s = [
  ...e,
  t.Substitution,
  t.CharacterCount,
  t.SimpleLink,
  t.SimpleHardBreak
];
export {
  i as advancedTextEditorExtensions,
  e as baseExtensions,
  r as emailTextExtensions,
  s as extensionsForSms,
  n as simpleTextExtensions
};
